module.exports = __webpack_public_path__ + "gxqgouche2212/static/img/foot.5d972f7e.png";